import React, { useEffect } from 'react';
import { Dashboard } from '../../components/Dashboard';

export const Home = () => {
  useEffect(() => {
    document.title = 'Dashboard';
  }, []);
  return <Dashboard />;
};
